export default __webpack_public_path__ + "static/media/ava-07.5db6ad24.png";